<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="700px"
  >
    <template slot="dialogTitle">
      Yacht Equipment Specs
    </template>
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <template v-for="specification in specificationsDirty">
        <specification-row
          :key="specification.key"
          :specification="specification"
          @update:specificationValue="updateSpecificationValue"
        />
      </template>
      <template v-for="(specification, index) in customSpecificationsDirty">
        <v-row
          :key="'custom_spec_'+index"
          class="list--bordered"
        >
          <v-col
            cols="8"
            class="d-flex align-center"
          >
            <v-text-field
              v-model="specification.title"
              outlined
              label="Title"
              dense
              hide-details
            />
          </v-col>
          <v-col
            cols="8"
          >
            <v-text-field
              v-model="specification.value"
              outlined
              label="Value"
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </template>
      <v-row class="list--bordered">
        <v-col>
          <v-btn
            color="primary"
            text
            small
            @click="addSpecRow"
          >
            <v-icon
              left
              small
            >
              fa fa-plus
            </v-icon>
            Add Spec Row
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Close
      </v-btn>
      <v-btn
        color="primary"
        :loading="saving"
        @click="save"
      >
        <v-icon left>
          check
        </v-icon>
        Save
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
  // import { cloneDeep } from 'lodash'
  import ContentDialog from '@/components/helpers/Dialog'
  import { mapState } from 'vuex'
  import SpecificationRow from '@/components/business/yachts/SpecificationRow'
  import Yacht from '@/models/Yacht'
  import { cloneDeep } from 'lodash'

  export default {
    name: 'YachtSpecificationsEditDialog',
    components: {
      SpecificationRow,
      ContentDialog
    },
    props: {
      specifications: {
        type: Array,
        default: () => []
      },
      yacht: {
        type: Object,
        required: true
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        specificationsDirty: [],
        customSpecificationsDirty: [],
        saving: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          // if (!value) this.updateSpecifications()
          this.$emit('update:visible', value)
        }
      },
      ...mapState('settings', ['yachtModelSpecs'])
    },
    watch: {
      specifications: function() {
        this.mapYachtSpecs()
      },
      yachtModelSpecs: function() {
        this.mapYachtSpecs()
      }
    },
    created() {
      this.mapYachtSpecs()

      if (this.yacht.custom_specifications) this.customSpecificationsDirty = cloneDeep(this.yacht.custom_specifications)
    },
    methods: {
      mapYachtSpecs() {
        if (this.yachtModelSpecs.loading) return

        this.specificationsDirty = this.yachtModelSpecs.data.map(spec => {
          // try to find value
          let s = this.specifications.find(s => s.key === spec.key)
          return {
            key: spec.key,
            title: spec.title,
            type: spec.type,
            value: s ? s.value : null,
            selectable: spec.selectable,
            multiple: spec.multiple
          }
        })
      },
      updateSpecificationValue(value, key) {
        let specification = this.specificationsDirty.find(s => s.key === key)
        let index = this.specificationsDirty.findIndex(s => s.key === key)

        specification.value = value

        let specifications = this.specificationsDirty

        this.$set(specifications, index, specification)

        this.specificationsDirty = specifications
      },
      async save() {
        this.saving = true

        try {
          let data = {
            specifications: this.yachtModelSpecs.data.map(spec => {
              return {
                key: spec.key,
                value: this.specificationsDirty.find(s => s.key === spec.key).value
              }
            }),
            custom_specifications: this.customSpecificationsDirty.filter(s => s.title && s.value)
          }

          let yacht = await Yacht.api.updateSpecifications(this.yacht.id, data)

          this.$emit('update:yacht', yacht)

          this.modalVisible = false

          this.$store.dispatch('alert', {
            text: 'Specs successfully saved!',
            color: 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            text: 'Something went wrong',
            color: 'error'
          })

          throw e
        } finally {
          this.saving = false
        }
      },
      addSpecRow() {
        this.customSpecificationsDirty.push({
          title: '',
          value: ''
        })
      }
    }
  }
</script>
